export default {
  getListGroupAlias (state) {
    return state.group_aliases
  },
  getLastPage (state) {
    return state.last_page
  },
  getTotal (state) {
    return state.total
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-alias/getters.js